module.exports = function() {
	return new Worker(__webpack_public_path__ + "e49daa7a80fbec29650a.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/GenerationSampleWorker.worker.js
// module id = 324
// module chunks = 0